import { Nullable } from "@utils/types";

import { Maybe, SavingsRate } from "@/@generated/graphql/types";

export interface ContractWithSavingsRate {
  savingsRate?: Maybe<SavingsRate>;
}

export const getBasicSavingsRatePercent = (contract: ContractWithSavingsRate): Nullable<number> =>
  contract?.savingsRate?.basic?.savingsRatePercent ?? null;
